export default "__VITE_ASSET__94d5847f__"